/** Production app URL — used for email links when signing up from localhost */
const DEFAULT_APP_URL = 'https://amcarehub.com';

/**
 * Base URL for the deployed app (no trailing slash).
 * Email confirmation and password-reset links must use this host so Supabase
 * can redirect back to a live /confirm-email or /reset-password route.
 */
export function getAppBaseUrl(): string {
  const configured =
    import.meta.env.VITE_APP_URL ||
    import.meta.env.VITE_PRODUCTION_URL;

  if (configured) {
    return String(configured).replace(/\/$/, '');
  }

  const host = window.location.hostname;
  const isLocal =
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.endsWith('.local');

  if (isLocal) {
    return DEFAULT_APP_URL;
  }

  return window.location.origin;
}

/**
 * Redirect URL passed to Supabase auth (signUp, resetPasswordForEmail).
 * Must be listed under Authentication → URL Configuration → Redirect URLs.
 */
export function getAuthRedirectUrl(path: string = ''): string {
  const base = getAppBaseUrl();
  const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : '';
  return `${base}${normalizedPath}`;
}
